export default __webpack_public_path__ + "static/media/user_dashboard_5.c9b9b1e0.png";